import parseHtml from "@utils/parseHtml";
import { $ } from "@utils/select";

export default ({ url }) => ({
  url,
  async requestRecommendations() {
    const response = await fetch(url);

    if (response.status !== 200) {
      console.error(response.statusText);
      return;
    }

    const html = await response.text();
    const $dom = parseHtml(html);

    this.$refs.container.parentNode.replaceChild(
      $('[x-ref="container"]', $dom),
      this.$refs.container
    );
  },
});
